<template>
  <div>
    <div class="row">
      <div class="col-md-12">

        <div class="form-group">
          <label for="company-name">Razão Social*</label>
          <input v-model="currentProvider.name" type="text" class="form-control" id="company-name" aria-describedby="emailHelp">
        </div>

        <div class="form-group">
          <label for="company-cnpj">CNPJ*</label>
          <input v-model="currentProvider.cnpj" type="text" class="form-control" id="company-cnpj" v-mask="'XX.XXX.XXX/XXXX-##'">
        </div>

        <div class="form-group">
          <label for="company-ie" v-tooltip.right="{ content: infoIE(), class: 'tooltip-in-modal'}">
            IE <info-icon size="1x"/>
          </label>
          <input v-model="currentProvider.ie" type="text" class="form-control" id="company-ie">
        </div>

        <div class="form-group">
          <label for="company-im">IM</label>
          <input v-model="currentProvider.im" type="text" class="form-control" id="company-im">
        </div>

        <div class="form-group">
          <label>UF*</label>
          <StatesSelect v-model="currentProvider.uf" class="custom-select"/>
        </div>

        <div class="form-group">
          <label for="company-code-city">Cidade*</label>
          <CitySelect v-model="currentProvider.cityCode" :code-uf="currentProvider.uf" id="company-code-city" class="custom-select"/>
        </div>

        <div class="form-group">
          <label for="company-phone">Telefone</label>
          <input v-model="currentProvider.phone" id="company-phone" type="text" class="form-control" v-mask="'(##) #### #####'">
        </div>

        <div class="form-group">
          <label for="company-email">Email</label>
          <input v-model="currentProvider.email" id="company-email" type="text" class="form-control">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-outline mr-2" @click="$emit('cancel')">Cancelar</button>
        <button class="btn btn-primary" @click="save" :disabled="disabledSaveButton">Salvar</button>
      </div>
    </div>

  </div>
</template>

<script>
  import CitySelect from '@/components/shares/specialTag/CitySelect'
  import ModelMapper from '@/mixins/ModelMapper'
  import StatesSelect from '@/components/shares/specialTag/StatesSelect'
  import { InfoIcon } from 'vue-feather-icons'
  import { mask } from 'vue-the-mask'

  export default {
    components: { CitySelect, InfoIcon, StatesSelect },
    computed: {
      disabledSaveButton() {
        return  !this.currentProvider.uf ||
          !this.currentProvider.name ||
          !this.currentProvider.cnpj
      }
    },
    created() {
      if (this.provider)
        this.currentProvider = {...this.provider}

      this.currentProvider.type = 'provider'
    },
    data: () => ({
      currentProvider: {},
      nameModel: 'Company'
    }),
    directives: { mask },
    methods: {
      infoIE() {
        return 'Caso este campo não seja preenchido, iremos considerar o estabelecimento como isento, ok?'
      },
      save() {
        this.asyncTemplateSave(this.currentProvider, {
          after: ({model}) => {
            this.$notify.add('Fornecedor salvo com Sucesso!')
            this.$emit('saved', model)
            this.currentProvider = model
          }
        })
      },
    },
    mixins: [ModelMapper],
    name: 'FormProvider',
    props: {
      provider: { default: null, type: Object },
    }
  }
</script>

<style scoped>
  .btn {
    min-width: 134px;
  }

  p {
    color: black;
  }

</style>
